<script>
import BasePopup from '@/components/BasePopup.vue';

export default {
  name: 'AccountBlockedNotifier',
  components: { BasePopup },
  data() {
    return {
      isPopupOpened: false,
    };
  },
  computed: {
    isAccountBlocked() {
      const user = this.$store.state.auth?.user;
      return user ? user.accountBlocked : false;
    },
  },
};
</script>

<template lang="pug">
  .b-account-blocked-notifier
    BasePopup(v-if="isPopupOpened" @close="isPopupOpened = false")
      ._popup-title Ваш аккаунт заблокирован
      Link(:to="{ name: 'tariffs' }") Пополните счёт или перейдите на бесплатный тариф.
    ._warning(v-if="isAccountBlocked" @click="isPopupOpened = true")
      Icon(name="danger" pointer)
</template>

<style scoped lang="scss">
.account-blocked-notifier {
  &__popup-title {
    font-size: 25px;
    margin-bottom: 30px;
    text-align: center;
  }

  &__warning {
    border-radius: 8px;
    border: 1px solid #DB3E3E;
    padding: 8px;
    position: fixed;
    bottom: 30px;
    right: 30px;
    z-index: 999999999999999999999999999;
  }
}
</style>
